/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React from 'react';
import {Checkbox} from "../../atoms/forms/Checkbox";
import Block from "../../atoms/layout/Block";

export const TagListItem = ({ tag, checked, onTagSelect, size }) => {
    return (<Block key={tag.id}>
        <Checkbox id={tag.id} label={tag.title} size={size} selected={checked} onChange={() => onTagSelect(tag.id)}/>
    </Block>)
};

export const TagList = ({ title = "", tags, className = "", selected, size, onTagSelect,
                          uncheckedItem = TagListItem, checkedItem = TagListItem, collapsed = false }) => (

    <div className={`tag-list ${className}`}>
        {title && <div className="tag-list__title">{title}</div>}
        <div className="tag-list__list">
            {!collapsed && tags.sort((a, b) => a.title.localeCompare(b.title)).map(tag => {
                const checked = selected.find(select => select.id === tag.id);
                const Item = checked ? checkedItem : uncheckedItem;

                return <Item key={tag.id + "-" + (checked ? "checked" : "unchecked")} size={size} tag={tag}
                             checked={checked} onTagSelect={onTagSelect}/>;
            })}
        </div>
    </div>

);
